module.exports = __webpack_public_path__ + "assets/img/Type E (9).2e581f3c.jpg";